import React, { useState } from 'react';
import EditDrawer from 'containers/Manage-Admin/email-templates/Drawer';
import { ResultsData, ResultsRow } from 'components/styled-components';
import { Button } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import styled from 'styled-components';

const Row = ({ template, fetch }) => {
  const [isOpen, toggleOpen] = useState(false);
  return (
    <ResultsRow>
      <TableDataWithHeaders>
        {template.type.replace(/_/g, ' ')}
      </TableDataWithHeaders>
      <TableDataWithHeaders>{template.description}</TableDataWithHeaders>
      <TableDataWithHeaders>{template.subject}</TableDataWithHeaders>
      <TableDataWithHeaders>
        <Button onClick={toggleOpen} minimal icon={IconNames.EDIT} />
      </TableDataWithHeaders>

      <EditDrawer
        template={template}
        isOpen={isOpen}
        toggleOpen={toggleOpen}
        fetch={fetch}
      />
    </ResultsRow>
  );
};

const TableDataWithHeaders = styled(ResultsData)`
  @media only screen and (max-width: 760px),
    (min-width: 761px) and (max-width: 1024px) {
    /*
	Label the data
	*/
    &:nth-of-type(1):before {
      content: 'Type';
    }
    &:nth-of-type(2):before {
      content: 'Description';
    }
    &:nth-of-type(3):before {
      content: 'Subject';
    }
    &:nth-of-type(4):before {
      content: 'Edit';
    }
  }
`;

export default Row;
